// ─────────────────────────────────────────────────────────────────────────────
// import
// ─────────────────────────────────────────────────────────────────────────────

import styled from 'styled-components';

// ─────────────────────────────────────────────────────────────────────────────
// component
// ─────────────────────────────────────────────────────────────────────────────

export const Label = styled.label`
  display: flex;
  align-items: center;
  color: hsla(var(--hsl-text), 0.75);
  font-size: 1.25rem;
  line-height: 3rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;
